var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({},_vm.$listeners),[_c('p',[_vm._v("URL")]),_c('BaseInput',{model:{value:(_vm.data.url),callback:function ($$v) {_vm.$set(_vm.data, "url", $$v)},expression:"data.url"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }